/**
 * Fuzzy date input types.
 */
export enum FuzzyDateInputType {
  ExactDate,
  FuzzyDate,
  Present,
}
